import { Phone, Mail, Linkedin, Building2 } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { BRAND } from "@/lib/constants";

const LINKEDIN_URL = "https://www.linkedin.com/in/eilon-stemmer-5105811a8/";

export default function AboutTab() {
  const showLinkedin = !LINKEDIN_URL.includes("REPLACE-ME");

  return (
    <div className="w-full space-y-6">
      {/* Founder card */}
      <Card>
        <CardContent className="pt-6">
          <div className="flex items-start gap-6">
            {/* Monogram avatar */}
            <div
              className="w-16 h-16 rounded-full flex items-center justify-center shrink-0 text-white text-xl font-bold"
              style={{ backgroundColor: BRAND.bg }}
            >
              ES
            </div>

            <div className="flex-1 space-y-4">
              <div>
                <h2 className="text-xl font-bold text-gray-900">Eilon Stemmer</h2>
                <p className="text-sm text-gray-500 mt-0.5">Founder</p>
              </div>

              {/* Contact rows */}
              <div className="space-y-3">
                <a
                  href="tel:+972584442578"
                  className="flex items-center gap-3 group"
                >
                  <div
                    className="w-8 h-8 rounded-md flex items-center justify-center shrink-0"
                    style={{ backgroundColor: BRAND.soft }}
                  >
                    <Phone className="w-4 h-4" style={{ color: BRAND.text }} />
                  </div>
                  <div>
                    <p
                      className="text-sm font-medium group-hover:underline"
                      style={{ color: BRAND.text }}
                    >
                      +972 58-444-2578
                    </p>
                    <p className="text-xs text-gray-500">Available 24/7</p>
                  </div>
                </a>

                <a
                  href="mailto:eilon@elementarai.com"
                  className="flex items-center gap-3 group"
                >
                  <div
                    className="w-8 h-8 rounded-md flex items-center justify-center shrink-0"
                    style={{ backgroundColor: BRAND.soft }}
                  >
                    <Mail className="w-4 h-4" style={{ color: BRAND.text }} />
                  </div>
                  <p
                    className="text-sm font-medium group-hover:underline"
                    style={{ color: BRAND.text }}
                  >
                    eilon@elementarai.com
                  </p>
                </a>

                {showLinkedin && (
                  <a
                    href={LINKEDIN_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center gap-3 group"
                  >
                    <div
                      className="w-8 h-8 rounded-md flex items-center justify-center shrink-0"
                      style={{ backgroundColor: BRAND.soft }}
                    >
                      <Linkedin className="w-4 h-4" style={{ color: BRAND.text }} />
                    </div>
                    <p
                      className="text-sm font-medium group-hover:underline"
                      style={{ color: BRAND.text }}
                    >
                      LinkedIn profile
                    </p>
                  </a>
                )}
              </div>
            </div>
          </div>
        </CardContent>
      </Card>

      {/* Company card */}
      <Card>
        <CardContent className="pt-6">
          <div className="flex items-center gap-3">
            <div
              className="w-9 h-9 rounded-lg flex items-center justify-center shrink-0"
              style={{ backgroundColor: BRAND.soft }}
            >
              <Building2 className="w-5 h-5" style={{ color: BRAND.text }} />
            </div>
            <div>
              <p className="text-sm font-semibold text-gray-900">Elementar</p>
              <p className="text-xs text-gray-500">Swiss-domiciled</p>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
